import { useQuery } from 'react-query';

import { QueryStateValue } from 'hooks/useQueryState';

import { getMapping as queryFn } from 'api/endPoints/getMapping';

import { IMappingData } from 'components/pages/PhasePerformanceManagePage/components/Manage/Manage.types';

export const useQueryGetMapping = (params: QueryParams) => {
    return useQuery<IMappingData, QueryError>(['phasePerformanceMapping', params], () => queryFn(params), {
        enabled:
            Boolean(params.template_id) &&
            Boolean(params.contract_id) &&
            Boolean(params.contractUuid) &&
            Boolean(params.phase_template_id),
        cacheTime: 0,
    });
};

export interface QueryParams {
    template_id: QueryStateValue;
    contract_id: number | undefined;
    contractUuid?: string | null;
    phase_template_id: QueryStateValue;
}
